module.exports = __webpack_public_path__ + "img/bg_01@2x.b308fdfe.png";